import encryptServer from '@/request/encryptRequest';

// 查询 询价单 分页列表 计数
export const getCountInquiry = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/count', params);
};

// 导出询单备件信息
export const exportSparePart = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/exportSparePart', params, {
    responseType: 'blob',
  });
};
// 查询 询价单 分页列表
export const pageListByInquiry = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/pageList', params);
};

// 查询 询价单 详情
export const getDetailByInquiry = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/detail', params);
};

// 查询 询价单报价 列表
export const listByInquireQuote = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/quotePriceList', params);
};

// 询价单 关单
export const closeInquiry = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/close', params);
};
// 询单备件分页列表
export const getSparePartPageList = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/sparePartPageList', params);
};
// 查询 查询供应商历史报价 列表
export const historyQuotePriceList = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/historyQuotePriceList', params);
};

// 查询日志 分页列表
export const queryLogPageList = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/inquirePrice/dynamicInformationPageList', params);
};

// 查询 寄修单、备用机 分页列表
export const sendRepairPageList = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/sendRepair/pageListByOpen', params);
};

// 查询 寄修单、备用机 详情
export const sendRepairDetail = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/sendRepair/detail', params);
};

export const xzptDynamicInformationXmbPageList = (params) => {
  return encryptServer.post('/xiaozi-saas/wireless/dynamicInformation/xmb/pageList', params);
};
